/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S11_P1Inputs */

const tr_mesafeli_s11_p1 = /** @type {(inputs: Mesafeli_S11_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hizmet'in ifasında aşağıdaki alt yükleniciler görev alır:`)
};

const en_mesafeli_s11_p1 = /** @type {(inputs: Mesafeli_S11_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The following sub-processors take part in the performance of the Service:`)
};

const de_mesafeli_s11_p1 = /** @type {(inputs: Mesafeli_S11_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An der Erbringung der Leistung sind folgende Unterauftragnehmer beteiligt:`)
};

const ru_mesafeli_s11_p1 = /** @type {(inputs: Mesafeli_S11_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В оказании Услуги участвуют следующие субобработчики:`)
};

/**
* | output |
* | --- |
* | "The following sub-processors take part in the performance of the Service:" |
*
* @param {Mesafeli_S11_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s11_p1 = /** @type {((inputs?: Mesafeli_S11_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S11_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s11_p1(inputs)
	if (locale === "de") return de_mesafeli_s11_p1(inputs)
	if (locale === "ru") return ru_mesafeli_s11_p1(inputs)
	return tr_mesafeli_s11_p1(inputs)
});